import { useQuery } from "@tanstack/react-query";
import {
  getRegisterFilterOptions,
  getSpofCard,
  searchRegister,
  type RegisterSelection,
  type RegisterSort,
} from "../api/spofRegister";

export function useRegisterFilterOptions(selection: RegisterSelection) {
  return useQuery({
    queryKey: ["spof-register", "filters", selection],
    queryFn: () => getRegisterFilterOptions(selection),
    placeholderData: (previous) => previous,
  });
}

export function useRegisterSearch(
  selection: RegisterSelection,
  sort: RegisterSort,
  page: number,
  pageSize: number,
) {
  return useQuery({
    queryKey: ["spof-register", "search", selection, sort, page, pageSize],
    queryFn: () => searchRegister(selection, sort, page, pageSize),
    placeholderData: (previous) => previous,
  });
}

export function useSpofCard(plantId: string, spofId: string) {
  return useQuery({
    queryKey: ["spof-register", "card", plantId, spofId],
    queryFn: () => getSpofCard(plantId, spofId),
  });
}
